var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pay-container" }, [
    _c("p", { staticClass: "text" }, [_vm._v("请切换APP查看订单")]),
    _c("p", { staticClass: "btn", on: { click: _vm.toIosApp } }, [
      _vm._v("前往法临APP")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }